(function($) {
    $(document).ready(function($) {

        //hash link click
        $('a[href*="#"]').not('#filterDropdown, .search-trigger').on('click', function(e) 
        {
            e.preventDefault();
            var $this = $(this);
            var $hash = $this.attr('href');
            var $link_hash = $this.prop("hash");

            console.log($hash, $link_hash);

            
            if( $hash.indexOf('http') >= 0)
            {
                window.location = $hash;
            }
            else if ($link_hash != '' && $($link_hash).length > 0) {
                //2# Hash link click for same page                      
                $('html, body').animate({
                    //scrollTop: $($(this).attr('href')).offset().top
                    scrollTop: parseInt($($link_hash).offset().top - 250)
                }, 600, 'swing');
            } else if ($hash != $link_hash && $hash != '') {
                //3# Hash based external link
                window.location = $hash;
            }

        });
    });

    //1# Jump based on window hash url
    var windowhash = window.location.hash;
    if (windowhash != '' && $(windowhash).length > 0) 
    {
        $('html, body').animate({
            scrollTop: parseInt($(windowhash).offset().top - 300)
        }, 600, 'swing');
    }

})(jQuery);